import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthService } from '../services/auth.service';

function isAuthEndpoint(url: string): boolean {
  const normalized = url.toLowerCase();
  return (
    normalized.includes('/auth/signin') ||
    normalized.includes('/auth/login') ||
    normalized.includes('/auth/signup') ||
    normalized.includes('/auth/forgot-password')
  );
}

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const auth = inject(AuthService);
  const token = auth.getToken();

  if (!token || req.headers.has('Authorization') || isAuthEndpoint(req.url)) {
    return next(req);
  }

  return next(
    req.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`,
      },
    })
  );
};
